__turbopack_context__.v({
  "container": "_6ipBUG_container",
  "logo": "_6ipBUG_logo",
});
